"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UniV2LikePairContract = void 0;
const ethers_1 = require("ethers");
const abi_1 = require("../../abi/abi");
const address_1 = require("../../utils/address");
class UniV2LikePairContract {
    contract;
    constructor(address, provider) {
        if (!(0, address_1.validateContractAddress)(address)) {
            throw new Error('Invalid pair address for LP router contract');
        }
        this.contract = new ethers_1.Contract(address, abi_1.abi.liquidity.uniV2LikePair, provider);
    }
    async getReserves() {
        const { _reserve0, _reserve1 } = await this.contract.getReserves();
        return {
            reserveA: _reserve0,
            reserveB: _reserve1,
        };
    }
    async totalSupply() {
        const totalSupply = await this.contract.totalSupply();
        return totalSupply;
    }
    async kLast() {
        return this.contract.kLast();
    }
}
exports.UniV2LikePairContract = UniV2LikePairContract;
